














































export default {
    props: {
        ibanvalidation: Object,
    },
};
